import ConfigCrudPage from '../../components/common/ConfigCrudPage';
import { getConfigCrudDefinition } from './configCrudDefinitions';

const config = getConfigCrudDefinition('drug', 'reference-datasets');

const DrugReferenceDatasets = () => (
  <ConfigCrudPage
    title={config.title}
    subtitle={config.subtitle}
    storageKey={config.storageKey}
    storageVersion={config.storageVersion}
    seedRows={config.seedRows}
    columns={config.columns}
    fields={config.fields}
    addButtonLabel={config.addButtonLabel}
  />
);

export default DrugReferenceDatasets;

